import React from 'react';
import Button from '../ui/Button';
import { MessageCircleIcon, GlobeIcon } from 'lucide-react';
import { trackContact } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
import { getWhatsAppLink } from '../../utils/whatsappLink';
const Header = () => {
  const {
    t,
    language,
    toggleLanguage
  } = useLanguage();
  const handleCtaClick = () => {
    trackContact({
      location: 'header',
      language,
      action: 'scroll_to_form'
    });
  };
  return <header className="bg-premium-gradient text-white py-3 px-4 sticky top-0 z-50 shadow-md" data-id="element-56" data-mp="hzrf8tavs9ev">
      <div className="container mx-auto flex items-center justify-between" data-id="element-57" data-mp="vqcrw09qrn4b">
        {/* Logo Area - Simplified for mobile */}
        <div className="font-heading font-bold text-lg md:text-xl tracking-tight" data-id="element-58" data-mp="qyuxjv284ksb">
          Pedro <span className="text-accent" data-id="element-59" data-mp="39jxkfsp6uf8">de la Cruz</span>
        </div>

        <div className="flex items-center gap-3 md:gap-4" data-id="element-60" data-mp="3ugwd6qdxmzt1">
          {/* Language Toggle */}
          <button onClick={toggleLanguage} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-sm font-medium" aria-label="Switch language" data-id="element-61" data-mp="6vombsne8v2r">
            <GlobeIcon className="w-4 h-4 text-accent" data-id="element-62" data-mp="gmt573g6x02v" />
            <span data-id="element-63" data-mp="lkbcyqih199a">{language === 'es' ? 'Español' : 'English'}</span>
          </button>

          {/* Desktop CTA - Now scrolls to form */}
          <div className="hidden md:block" data-id="element-64" data-mp="3k3i8mgkh7tob">
            <Button href="#lead-form" variant="success" className="bg-[#25D366] hover:bg-[#20bd5a] shadow-md font-bold" onClick={handleCtaClick} data-id="element-65" data-mp="3p1a2hg4olpv5">
              {language === 'es' ? 'Solicita tu carro' : 'Get your car'}{' '}
              <MessageCircleIcon className="w-4 h-4 ml-2" data-id="element-66" data-mp="1u94e9gij4ol" />
            </Button>
          </div>

          {/* Mobile CTA (icon only) - Now scrolls to form */}
          <div className="md:hidden" data-id="element-67" data-mp="1dafsaardj63n">
            <a href="#lead-form" className="inline-flex items-center justify-center p-2 rounded-full bg-[#25D366] text-white shadow-lg animate-pulse" aria-label={t.header.ctaMobileLabel} onClick={handleCtaClick} data-id="element-68" data-mp="1ddlla134is4n">
              <MessageCircleIcon className="w-6 h-6" data-id="element-69" data-mp="3jaz0jr4bkd6i" />
            </a>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;